module.exports = __webpack_public_path__ + "static/media/yashAgrawal.fdcfa8b8.jpeg";